import React from "react";
import "./SecondPageTopSection.css";

interface SecondPageTopSectionProps {
  backgroundImage?: string; 
  logoImage?: string; 
  title?: string; 
  description?: string; 
  customStyles?: {
    container?: React.CSSProperties;
    title?: React.CSSProperties;
    description?: React.CSSProperties;
    avatar?: React.CSSProperties;
    content?: {
      bottom?: number;
      right?: number;
    };
  };
}

const SecondPageTopSection: React.FC<SecondPageTopSectionProps> = ({
  backgroundImage = "/default-background.jpg", 
  logoImage = "/default-logo.png",
  title = "Default Title",
  description = "Default Description", 
  customStyles = {}, 
}) => {
  return (
    <div
      className="second-page-top-section d-flex flex-column"
      style={{
        backgroundImage: `url(${backgroundImage})`, 
        backgroundSize: "cover",
        backgroundPosition: "center",
        ...customStyles.container,
      }}
    >
      
      <div className="overlay"></div>

  
      <div
        className="second-page-top-section-content"
        style={customStyles.content}
      >
  
        <div
          className="second-page-top-section-logo"
          style={{
            backgroundImage: `url(${logoImage})`, 
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            ...customStyles.avatar,
          }}
        ></div>

      
        <h3
          className="second-page-top-section-title"
          style={customStyles.title}
        >
          {title}
        </h3>

        <h6
          className="second-page-top-section-description"
          style={customStyles.description}
        >
          {description}
        </h6>
      </div>
    </div>
  );
};

export default SecondPageTopSection;
